<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>确定入库</span>
            <div style="float: right;">
              <el-button type="primary" size="small" @click="_goBack">
                <i class="el-icon-close"></i>返回
              </el-button>
            </div>
          </div>
      <div class="content">
        <el-row :gutter="20" class="text-left">
          <el-col :span="6">
            <div class="form-item">
              <label class="form-label">工单编码：</label>
              <span class="form-value">{{doAllocationOrderInfo.orderId}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-item">
              <label class="form-label">申请人:</label>
              <span class="form-value">{{doAllocationOrderInfo.staffName}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-item">
              <label class="form-label">申请时间:</label>
              <span class="form-value">{{doAllocationOrderInfo.createTime}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-item">
              <label class="form-label">订单状态:</label>
              <span class="form-value">{{doAllocationOrderInfo.stateName}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="text-left">
          <el-col :span="6">
            <div class="form-item">
              <label class="form-label">源商铺：</label>
              <span class="form-value">{{doAllocationOrderInfo.shopName}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-item">
              <label class="form-label">源仓库:</label>
              <span class="form-value">{{doAllocationOrderInfo.srcShName}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-item">
              <label class="form-label">目标商铺:</label>
              <span class="form-value">{{doAllocationOrderInfo.targetShopName}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-item">
              <label class="form-label">目标仓库:</label>
              <span class="form-value">{{doAllocationOrderInfo.targetShName}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row class="text-left">
          <el-col :span="24">
            <div class="form-item">
              <label class="form-label">审核备注:</label>
              <span class="form-value">{{doAllocationOrderInfo.stateRemark}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>商品信息</span>
          </div>
          <el-table :data="doAllocationOrderInfo.inoutOrderProducts" border style="width: 100%">
            <el-table-column prop="index" label="序号" width="100" align="center">
              <template slot-scope="scope">
                {{scope.$index + 1}}
              </template>
            </el-table-column>
            <el-table-column prop="productId" label="商品编号" align="center"></el-table-column>
            <el-table-column prop="prodName" label="商品名称" align="center"></el-table-column>
            <el-table-column prop="specName" label="规格" align="center"></el-table-column>
            <el-table-column prop="productCount" label="申请单数量" align="center"></el-table-column>
            <el-table-column label="实际数量" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.actCount" type="number"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="金额" align="center"></el-table-column>
          </el-table>
          <div style="margin-top: 20px; text-align: right;">
            <el-button type="warning" style="margin-right: 20px;" @click="_doCancelOrder">
              <i class="el-icon-close"></i>取消入库单
            </el-button>
            <el-button type="primary" @click="doInoutOrder">
              <i class="el-icon-check"></i>确定入库
            </el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { getDict } from '@/api/shop/shopApi'
import { queryProduct, warehousingAllocationOrder } from '@/api/goods/doAllocationOrderInApi'
import { queryAllocationOrder } from '@/api/goods/allocationOrderApi'

export default {
  data() {
    return {
      shopId: '',
      doAllocationOrderInfo: {
        orderId: '',
        stateName: '',
        state: '',
        staffId: '',
        staffName: '',
        createTime: '',
        remark: '',
        stateRemark: '',
        shopId: '',
        shopName: '',
        srcShId: '',
        srcShName: '',
        targetShId: '',
        targetShName: '',
        targetShopId: '',
        targetShopName: '',
        productCount: '',
        prodName: '',
        specName: '',
        specId: '',
        productId: '',
        actCount: '',
        inoutOrderProducts: []
      }
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(getDict)
    this._initMethod()
  },
  methods: {
    async _initMethod() {
      const orderId = this.$route.query.orderId
      if (!orderId) {
        this.$message.error('非法操作')
        this._goBack()
        return
      }
      
      this.doAllocationOrderInfo.orderId = orderId
      await this._listOrder()
      this._listInoutOrderProduct()
    },
    async _listOrder() {
      try {
        const param = {
          page: 1,
          row: 1,
          orderId: this.doAllocationOrderInfo.orderId
        }
        const res = await queryAllocationOrder(param)
        if (res.data && res.data.length > 0) {
          const orderData = res.data[0]
          Object.assign(this.doAllocationOrderInfo, {
            staffName: orderData.staffName,
            stateName: orderData.stateName,
            createTime: orderData.createTime,
            stateRemark: orderData.stateRemark,
            shopName: orderData.shopName,
            srcShName: orderData.srcShName,
            targetShopName: orderData.targetShopName,
            targetShName: orderData.targetShName,
            shopId: orderData.shopId,
            specId: orderData.specId,
            productId: orderData.productId,
            productCount: orderData.productCount,
            actCount: orderData.productCount,
            state: orderData.state,
            targetShId: orderData.targetShId,
            srcShId: orderData.srcShId,
            targetShopId: orderData.targetShopId,
            staffId: orderData.staffId,
            prodName: orderData.prodName,
            specName: orderData.specName
          })
        } else {
          this.$message.error('未找到订单信息')
          this._goBack()
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败')
        this._goBack()
      }
    },
    async _listInoutOrderProduct() {
      try {
        const param = {
          page: 1,
          row: 50,
          specId: this.doAllocationOrderInfo.specId,
          productId: this.doAllocationOrderInfo.productId,
          shopId: this.doAllocationOrderInfo.shopId
        }
        const res = await queryProduct(param)
        const products = res.data || []
        // 将商品数据转换为数组，并添加申请数量和实际数量
        if (products.length > 0) {
          this.doAllocationOrderInfo.inoutOrderProducts = products.map(product => ({
            ...product,
            productCount: this.doAllocationOrderInfo.productCount,
            actCount: this.doAllocationOrderInfo.actCount || this.doAllocationOrderInfo.productCount,
            specName: product.defaultSpecValue ? product.defaultSpecValue.specName : this.doAllocationOrderInfo.specName,
            price: product.defaultSpecValue ? product.defaultSpecValue.price : 0
          }))
        } else {
          // 如果没有查询到商品，至少显示一个商品信息
          this.doAllocationOrderInfo.inoutOrderProducts = [{
            productId: this.doAllocationOrderInfo.productId,
            prodName: this.doAllocationOrderInfo.prodName,
            specName: this.doAllocationOrderInfo.specName,
            productCount: this.doAllocationOrderInfo.productCount,
            actCount: this.doAllocationOrderInfo.actCount || this.doAllocationOrderInfo.productCount,
            price: 0
          }]
        }
        console.log('商品列表:', this.doAllocationOrderInfo.inoutOrderProducts)
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error('获取商品信息失败')
        // 即使查询失败，也显示基本信息
        this.doAllocationOrderInfo.inoutOrderProducts = [{
          productId: this.doAllocationOrderInfo.productId,
          prodName: this.doAllocationOrderInfo.prodName,
          specName: this.doAllocationOrderInfo.specName,
          productCount: this.doAllocationOrderInfo.productCount,
          actCount: this.doAllocationOrderInfo.actCount || this.doAllocationOrderInfo.productCount,
          price: 0
        }]
      }
    },
    async doInoutOrder() {
      try {
        // 从表格中获取实际数量
        if (this.doAllocationOrderInfo.inoutOrderProducts.length > 0) {
          this.doAllocationOrderInfo.actCount = this.doAllocationOrderInfo.inoutOrderProducts[0].actCount || this.doAllocationOrderInfo.productCount
        }
        this.doAllocationOrderInfo.state = "4004"
        const res = await warehousingAllocationOrder(this.doAllocationOrderInfo)
        if (res.code === 0) {
          this.$message.success(res.msg || "入库成功")
          this._goBack()
        } else {
          this.$message.error(res.msg || '入库失败')
        }
      } catch (error) {
        console.error('入库失败:', error)
        this.$message.error(error.message || error || '操作失败')
      }
    },
    async _doCancelOrder() {
      try {
        this.doAllocationOrderInfo.state = "3003"
        const res = await warehousingAllocationOrder(this.doAllocationOrderInfo)
        if (res.code === 0) {
          this.$message.success(res.msg || '取消成功')
          this._goBack()
        } else {
          this.$message.error(res.msg || '取消失败')
        }
      } catch (error) {
        console.error('取消失败:', error)
        this.$message.error(error.message || error || '操作失败')
      }
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.form-item {
  margin-bottom: 15px;
}
.form-label {
  display: inline-block;
  width: 80px;
  text-align: right;
  margin-right: 10px;
  color: #606266;
}
.form-value {
  color: #303133;
}
.box-card {
  margin-bottom: 20px;
}
.text-left {
  text-align: left;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>